// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"5ac98888","353":"fbac9fb4"}[chunkId] + ".chunk.css";
};